import { Navigate, Outlet, useLocation } from "react-router-dom";
import { UserStatusT } from "../context/GetLifeContext.context";
import { redirect } from "./redirect";

export interface RoutesI {
  token: string;
  userStatus: UserStatusT;
}
const PublicRoute = ({ token, userStatus }: RoutesI) => {
  const location = useLocation();

  // Permitir acceso a rutas /login/:otp incluso con sesión activa
  // Esto es necesario para permitir que los usuarios con una sesión del Lead A
  // puedan hacer clic en un enlace OTP del Lead B y cambiar de sesión
  const isOtpLoginRoute = location.pathname.match(/^\/login\/[^/]+/);

  return !token || !userStatus || isOtpLoginRoute ? (
    <Outlet />
  ) : (
    <Navigate to={redirect(userStatus) + location.search} />
  );
};

export default PublicRoute;
